import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useLazyRef } from 'modules/core/hooks/useLazyRef'

import { MaterializedApprovalFlows } from 'modules/approvals/store/collections/materializedApprovalFlows'

interface Props {
  resourceId: string
  resourceType: string
}

export const useMaterializedApprovalFlowApproverCheck = ({ resourceId, resourceType }: Props) => {
  const materializedApprovalFlowsCollection = useLazyRef(
    () => new MaterializedApprovalFlows()
  ).current

  const { loading } = useAsyncData(() => {
    return materializedApprovalFlowsCollection.fetch({
      data: { resource_ids: [resourceId], resource_type: resourceType, with_approvers: true },
    })
  }, [resourceId])

  const { access } = useCurrentSession()

  if (loading)
    return {
      loading,
      isCurrentApprover: undefined,
      canApproveFromFlow: undefined,
      isGlobalApprover: undefined,
    }

  const materializedApprovalFlow = materializedApprovalFlowsCollection.models[0]

  const curretnStepAccesses = materializedApprovalFlow
    ?.get('approvers')
    .filter((approver: { status: string }) => approver.status === 'pending')
    .flatMap((approver: { id: string; access_id: string }) => approver.access_id)

  const isCurrentAccessCurrentApproval = curretnStepAccesses?.includes(access.id)

  return {
    loading,
    isCurrentApprover: isCurrentAccessCurrentApproval,
    materializedApprovalFlowId: materializedApprovalFlow?.id,
    approvalFlowId: materializedApprovalFlow?.attributes.approval_flow_id,
    canApproveFromFlow: materializedApprovalFlow?.canApprove,
    isGlobalApprover: materializedApprovalFlow?.isGlobalApprover,
  }
}
